// 偶像篩選選項（共用於 IdolUpdate, IdolPage, IdolsPage）
// 使用函數生成多語系選項

// 性別選項
export const getGenderOptions = (t) => [
  { value: '0', label: t('male') },
  { value: '1', label: t('female') },
  { value: '2', label: t('other') }
];

// get-idol-info 回傳的性別是標籤，/idol/update 與上方選項用的是數字（0=男、1=女、2=其它，見 API 文件 2-2）
export const GENDER_LABEL_TO_VALUE = { Male: 0, Female: 1, Other: 2 };

// 性向選項
export const getSexualOrientationOptions = (t) => [
  { value: 'Heterosexual', label: t('heterosexual') },
  { value: 'Homosexual', label: t('homosexual') },
  { value: 'Bisexual', label: t('bisexual') },
  { value: 'Pansexual', label: t('pansexual') },
  { value: 'Asexual', label: t('asexual') },
  { value: 'Other', label: t('other') }
];

// 感情狀況選項
export const getRelationshipStatusOptions = (t) => [
  { value: 'Single', label: t('single') },
  { value: 'In_relationship', label: t('in_relationship') },
  { value: 'Engaged', label: t('engaged') },
  { value: 'Married', label: t('married') },
  { value: 'Open_relationship', label: t('open_relationship') },
  { value: 'Complicated', label: t('complicated') },
  { value: 'Divorced', label: t('divorced') }
];

// 創作類型選項
export const getPreferencesOptions = (t) => [
  { value: 'beauty_skincare', label: t('beauty_skincare') },
  { value: 'fashion_style', label: t('fashion_style') },
  { value: 'food_travel', label: t('food_travel') },
  { value: 'lifestyle', label: t('lifestyle') },
  { value: 'relationships', label: t('relationships') },
  { value: 'tech_3c', label: t('tech_3c') },
  { value: 'knowledge_skills', label: t('knowledge_skills') },
  { value: 'art_design', label: t('art_design') },
  { value: 'photography', label: t('photography') },
  { value: 'sports_fitness', label: t('sports_fitness') },
  { value: 'adult_content', label: t('adult_content') }
];

// 是否原創選項（radio）
export const getIsOriginalOptions = (t) => [
  { value: '', label: t('all') },
  { value: '1', label: t('yes') },
  { value: '0', label: t('no') }
];

// 是否工作場合不適選項（radio）
export const getIsNsfwOptions = (t) => [
  { value: '', label: t('all') },
  { value: '1', label: t('yes') },
  { value: '0', label: t('no') }
];
